import TagPrimitive, { TagProps } from './TagPrimitive';

export type { TagProps };

export default TagPrimitive;
